export default __webpack_public_path__ + "static/source-peakwork-928395efb6154d9b64aceec35044680e.svg";